<template>
    <v-expansion-panels class="tapes-expansion">
        <v-expansion-panel v-for="(item, id) in items" :key="id">
            <v-expansion-panel-header expand-icon="mdi-plus">
                <h2 class="tapes-expansion__title">{{ item.title }}</h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <p class="tapes-expansion__text" v-html="item.text">

                </p>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>

</template>

<script>
export default {
    name: "tapesExpansion",
    props: {
        elements: Array | Object | Boolean,
    },

    data() {
        return {
            /*items: [
                {
                    title: 'В каком формате нужно прислать макет? \n',
                    text: 'Работаем с любыми заказами: предупреждающие, маркетинговые надписи, ленты с логотипом. Адаптируем вашу идею или макет под печать на клейкой ленте и предложим решения, если исходный вариант требует доработки.'
                },
                {
                    title: 'Какой вид печати вы используете?',
                    text: 'Работаем с любыми заказами: предупреждающие, маркетинговые надписи, ленты с логотипом. Адаптируем вашу идею или макет под печать на клейкой ленте и предложим решения, если исходный вариант требует доработки.'
                },
            ]*/
            items: this.elements,
        }
    }
}
</script>

<style lang="scss">
.tapes-expansion {

  .v-expansion-panel {
    box-shadow: none;
    border-radius: 24px !important;
    border: 1px solid rgba(232, 232, 232, 1);

    &:hover {
      border-color: rgba(79, 77, 85, 1);
    }
  }

  .v-expansion-panel-header {
    padding: 32px 32px;
    display: flex;
    width: 100%;
  }

  .v-expansion-panel-header:before {
    display: none;
  }

  .v-expansion-panel.v-expansion-panel--active.v-item--active {
    border: 1px solid rgba(79, 77, 85, 1) !important;
  }

  .v-expansion-panel::before,
  .v-expansion-panel:after {
    box-shadow: none;
    display: none;
  }

  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 96px;
    padding-bottom: 28px;

    @media (max-width: 375px) {
      min-height: 120px;
    }
  }

  .v-expansion-panel--active > .v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
    transform: rotate(-135deg);
  }

  .mdi:before, .mdi-set {
    color: #252525;
    font-size: 36px;
  }

  .v-expansion-panel-content__wrap {
    padding: 0 32px 32px 32px;
  }
}

</style>

<style lang="scss" scoped>
.tapes-expansion {
  margin-top: 0;
  margin-left: 0;
  display: flex;
  gap: 12px;

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-style: 500;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: rgba(33, 36, 36, 1);
    margin: 0;

    @media (max-width: 425px) {
      font-size: 20px;
      line-height: 24px;
    }
  }

  &__text {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0px;
    color: #202020;
    margin: 0;

    @media (max-width: 425px) {
      font-size: 16px;
      line-height: 22px;
    }

    & a {
      color: #fa4237;
      text-decoration: underline transparent;

      &:hover {
        text-decoration: underline #fa4237;
      }
    }
  }
}
</style>